import {useAsset} from "../../../AssetHelper";
import {t} from "../../../i18n";
import {rightArrow} from "../../pages/AudienceKey";

import ScorePill from "../ScorePill";
import robotSvg from '@fortawesome/fontawesome-free/svgs/solid/robot.svg'
import arrowRight from '@fortawesome/fontawesome-free/svgs/solid/arrow-right.svg'
import ScoreBadge from "../ScoreBadge";
import {ReactSVG} from "react-svg";

export function AutoKey({color} : {
    color: 'red' | 'blue' | 'orange'
}) {
    const artifactSvg = useAsset('img/decode/artifact-white.svg');
    return <div className={"autoKey keySection"}>
        <div className={"audienceKeyRow"}>
            <span>ARTIFACTS</span>
            <span>OVERFLOW<br/>CLASSIFIED</span>
            <div className={"rowSymbols"}>
                <ScorePill icon={<div className={"d-flex flex-column w-100 h-100 justify-content-center align-items-center"}>
                    <div className={`svgWrapper fontAwesome`}>
                        <ReactSVG src={arrowRight} />
                    </div>
                    <div className={`svgWrapper`}>
                        <ReactSVG src={artifactSvg} />
                    </div>
                </div>} value={[
                    1,
                    2
                ]} goal={36} />
            </div>
        </div>
    </div>
}

export function TeleopKey({color} : {
    color: 'red' | 'blue' | 'orange'
}) {
    const artifactSvg = useAsset('img/decode/artifact-white.svg');
    return <div className={"autoKey keySection"}>
        <div className={"audienceKeyRow"}>
            <span>ARTIFACTS</span>
            <span>OVERFLOW<br/>CLASSIFIED</span>
            <div className={"rowSymbols"}>
                <ScorePill icon={<div className={"d-flex flex-column w-100 h-100 justify-content-center align-items-center"}>
                    <div className={`svgWrapper fontAwesome`}>
                        <ReactSVG src={arrowRight} />
                    </div>
                    <div className={`svgWrapper`}>
                        <ReactSVG src={artifactSvg} />
                    </div>
                </div>} value={[
                    3,
                    4
                ]} goal={36} />
            </div>
        </div>
        <div className={"audienceKeyRow"}>
            <span>{t`AUTO LEAVE Robots`}</span>
            <div className={"rowSymbols"}>
                <ScorePill icon={robotSvg} value={<span>
                    <i className={`fa fa-fw fa-check`}></i>
                    <i className={`fa fa-fw fa-times`}></i>
                </span>} />
            </div>
        </div>
        <div className={"audienceKeyRow"}>
            <span>{t`AUTO ARTIFACTS matching MOTIF`}</span>
            <div className={"rowSymbols"}>
                <ScorePill className={"mt-3"} icon={<div className={"motif"}>
                    <ReactSVG src={artifactSvg} />
                    <ReactSVG src={artifactSvg} />
                    <ReactSVG src={artifactSvg} />
                </div>} value={6} />
            </div>
        </div>
    </div>
}